import React, { useEffect, useState } from "react";
import Global from "./Global";
import { numberFormat } from "../repository";
import ImageZoomViewer from "./ProductImageZoomViewer";
import Modal360Viewer from "./Product360Viewer";
import ProductApplications from "../components/ProductApplications";

const OrderItem = (props) => {
  const [index] = useState(undefined);
  const [item] = useState(props.item);
  const [imageSource, setImageSource] = useState("");
  const [is360, set360] = useState(false);
  const [isModal360Open, setIsModal360Open] = useState(false);  
  const [isImageZoom, setIsImageZoom] = useState(false);
  const [codeSelected, setCodeSelected] = useState(null);

  const openImageZoomModal = () => {
    if (imageSource !== Global.foto_nd) setIsImageZoom(true);
  };

  function openAppsModal(e) {
    e.preventDefault();
    setCodeSelected(item);  
  }

  const closeAppsModal = () => {
    setCodeSelected(null);
  };

  const closeImageZoomModal = () => {
    setIsImageZoom(false);
  };

  const open360Modal = (e) => {
    e.preventDefault();
    setIsModal360Open(true);
  };

  const close360Modal = () => {
    setIsModal360Open(false);
  };

  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);
      img.src = url;
    });
  };

  useEffect(() => {
    let cancelled = false;

    const loadImages = async () => {
      const codigo = item.Producto;
      const fotoUrl = Global.fotos_URL + codigo.toLowerCase().replace(/-/g, "_") + ".jpg";
      const foto360Url = Global.urlFotos360 + codigo.toUpperCase() + "/images/img_0_0_0.jpg";

      const [fotoExists, foto360Exists] = await Promise.all([
        checkImageExists(fotoUrl),
        checkImageExists(foto360Url),
      ]);

      if (!cancelled) {
        setImageSource(fotoExists ? fotoUrl : Global.foto_nd);
        set360(foto360Exists);
      }
    };

    loadImages();

    return () => { cancelled = true; };
  }, [item.Producto]);

  return (
    <li className="list-group-item py-2">
      <div className="row align-items-center">
        <div className="col-md-2 text-center">
          <img
            className="card-img-top"
            style={{
              cursor: "pointer",
              maxWidth: "100%",
              height: "100px",
              objectFit: "contain",
            }}
            src={imageSource}
            alt={item.Codigo}
            onClick={() => openImageZoomModal()}
            data-toggle="modal"
            data-target={"#modalImageZoom" + item.Codigo}
          />
          {isImageZoom && (
            <ImageZoomViewer
              item={item}
              imageSource={imageSource}
              closeModal={closeImageZoomModal}
            />
          )}
          <div className="text-center mt-1">
            <button
              className="btn btn-outline-warning btn-sm rounded-pill mr-1"
              style={{ fontSize: "0.7rem", padding: "2px 8px" }}
              onClick={(e) => openAppsModal(e)}
              data-toggle="modal"
              data-target={"#modalApps" + item.Codigo}
            >
              APS
            </button>
            {is360 && (
              <button
                className="btn btn-outline-info btn-sm rounded-pill"
                style={{ fontSize: "0.7rem", padding: "2px 8px" }}
                onClick={(e) => open360Modal(e)}
                data-toggle="modal"
                data-target={"#modal360" + item.Codigo + index}
              >
                360
              </button>
            )}
            {codeSelected && (
              <ProductApplications
                codigo={item.Codigo}
                closeModal={closeAppsModal}
              />
            )}
            {isModal360Open && (
              <Modal360Viewer
                index={index}
                item={item}
                catalogo={true}
                closeModal={close360Modal}
              />
            )}
          </div>
        </div>
        <div className="col-md-7">
          <div className="d-flex align-items-center">
            <span className="badge badge-secondary mr-2" style={{ fontSize: "0.9rem" }}>
              {item.Producto}
            </span>
          </div>
          <span className="text-muted" style={{ fontSize: "0.95rem" }}>{item.Descripcion}</span>
          <div>
            <span style={{ fontSize: "0.95rem" }}>
              <strong>Cantidad:</strong> {item.Cantidad}
            </span>
          </div>
        </div>
        <div className="col-md-3 text-right">
          <span className="badge badge-pill badge-primary" style={{ fontSize: "1rem" }}>
            ${numberFormat(item.Precio)}
          </span>
        </div>
      </div>
    </li>
  );
};

export default OrderItem;
